import React from "react";
import { setHeaderCollapse } from "../data/redux/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import queryClient from "../../config/queryClient";
import { IoReload } from "react-icons/io5";

const CollapseHeader = () => {
  const dispatch = useDispatch();
  const { headerCollapse } = useSelector((state) => state.crms);

  const toggleHeaderCollapse = () => {
    dispatch(setHeaderCollapse(!headerCollapse));
  };

  // const handleRefresh = () => {
  //   queryClient.invalidateQueries(moduleName);
  // };

  return (
    <div className="d-flex justify-content-end gap-2">
      {/* {moduleName && (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="refresh-tooltip">Refresh</Tooltip>}
        >
          <div role="button" id="collapse-header" onClick={handleRefresh}>
            <IoReload size={20} />
          </div>
        </OverlayTrigger>
      )} */}
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="collapse-tooltip">Collapse</Tooltip>}
      >
        <div
          id="collapse-header"
          onClick={toggleHeaderCollapse}
          role="button"
          tabIndex={0} // Makes it keyboard accessible
          onKeyDown={(e) => e.key === "Enter" && toggleHeaderCollapse()} // Handle Enter key
        >
          <i className="ti ti-chevrons-up" />
        </div>
      </OverlayTrigger>
    </div>
  );
};

export default CollapseHeader;
